module.exports = __webpack_public_path__ + "img/risk-shipment.05686643.jpg";